export default __webpack_public_path__ + "static/media/suwa_large_desktop.da102ad9.png";